import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient) { }


  getPdfPolytique(companyId){
    console.log('test companyId'+companyId)
        return this.http.get(`${environment.api}users/getPdfPolytique/${companyId}`, { responseType: 'blob' })
  }
}
